module.exports = __webpack_public_path__ + "static/img/map-mark.ae7536e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/map-mark.png
// module id = ITwb
// module chunks = 0